"use client";

import { useEffect, useState } from "react";

const SIZES = [["standard", "标准"], ["large", "大字"], ["largest", "更大"]] as const;

export function TypeSize() {
  const [size, setSize] = useState("standard");
  useEffect(() => {
    let saved = "standard";
    try { saved = localStorage.getItem("portal-type-size") ?? saved; } catch { /* 存储关闭时保留默认字号 */ }
    if (SIZES.some(([key]) => key === saved)) {
      document.documentElement.dataset.portalType = saved;
      // 字号显示与已保存设置同步，不保存公开内容。
      queueMicrotask(() => setSize(saved));
    }
  }, []);
  return <div className="type-controls" role="group" aria-label="阅读字号">
    <span className="type-controls__label" aria-hidden="true">字号</span>
    <span className="type-controls__group">{SIZES.map(([key, label]) =>
      <button key={key} type="button" aria-pressed={size === key} onClick={() => {
        setSize(key); document.documentElement.dataset.portalType = key;
        try { localStorage.setItem("portal-type-size", key); } catch { /* 仅本次阅读生效 */ }
      }}>{label}</button>)}</span>
  </div>;
}

export function SearchBox({ initialQuery = "" }: { initialQuery?: string }) {
  const [q, setQ] = useState(initialQuery);
  const [error, setError] = useState("");
  function submit() {
    const query = q.trim();
    if (Array.from(query).length < 2 || Array.from(query).length > 40) { setError("请输入二至四十个字。"); return; }
    setError(""); window.location.assign(`/search?q=${encodeURIComponent(query)}`);
  }
  return <div className="search-box">
    <label htmlFor="public-search">检索公开内容</label>
    <div className="search-controls"><input id="public-search" type="search" value={q} placeholder="输入关键词" onChange={event => setQ(event.target.value)} onKeyDown={event => { if (event.key === "Enter" && !event.nativeEvent.isComposing) submit(); }} aria-describedby="search-hint" />
      <button type="button" onClick={submit}>检索</button></div>
    <p id="search-hint" role={error ? "alert" : undefined}>{error || "输入二至四十个字，只检索已经公开的标题、摘要与专题。"}</p>
  </div>;
}
